"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var skinToHeaderColumnMap = {
    GridSkin: 'none',
    GridLeftHeaderSkin: 'first',
    GridRightHeaderSkin: 'last',
};
var horizontalContentAlignmentMap = {
    center: 'center',
    left: 'flex-start',
    right: 'flex-end',
};
var mapPagination = function (_a) {
    var type = _a.type, rowsPerPage = _a.rowsPerPage;
    return ({
        type: type,
        rowsPerPage: rowsPerPage,
    });
};
exports.props = withCompInfo_1.withCompInfo(['skin', 'compProps', 'compData', 'compLayout', 'topology'], function (_a) {
    var skin = _a.skin, _b = _a.compProps, columns = _b.columns, showHeader = _b.showHeader, pagination = _b.pagination, userSelectionType = _b.userSelectionType, dateFormat = _b.dateFormat, linkTarget = _b.linkTarget, columnLayout = _b.columnLayout, rowHeight = _b.rowHeight, _c = _a.compData, rows = _c.rows, dataSource = _c.dataSource, width = _a.compLayout.width, staticMediaUrl = _a.topology.staticMediaUrl;
    return ({
        dataSource: dataSource.type,
        columns: columns,
        rows: rows,
        headerColumn: skinToHeaderColumnMap[skin],
        showHeader: showHeader,
        pagination: mapPagination(pagination),
        userSelectionType: userSelectionType,
        dateFormat: dateFormat,
        linkTarget: linkTarget,
        columnLayout: columnLayout,
        staticMediaUrl: staticMediaUrl,
        rowHeight: rowHeight,
        width: width,
    });
});
exports.css = withCompInfo_1.withCompInfo(['compProps', 'styleProperties'], function (_a) {
    var _b = _a.compProps, headerHeight = _b.headerHeight, rowHeight = _b.rowHeight, heightLayout = _b.heightLayout, horizontalAlignment = _b.horizontalAlignment, cellPadding = _a.styleProperties.cellPadding;
    return (__assign(__assign(__assign(__assign({}, (heightLayout === 'auto' && { height: 'auto' })), { '--headerHeight': headerHeight + "px", '--rowHeight': rowHeight + "px", '--horizontalTextAlignment': horizontalAlignment, '--horizontalContentAlignment': horizontalContentAlignmentMap[horizontalAlignment] }), (horizontalAlignment === 'left' && { '--cellPaddingLeft': cellPadding })), (horizontalAlignment === 'right' && {
        '--cellPaddingRight': cellPadding,
    })));
});
//# sourceMappingURL=Grid.js.map